import styled from 'styled-components';
import { Text } from 'xpi-black-ui/Base/Typography';

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .selectOrderBy {
    z-index: 5;
    width: 210px;
  }
`;

export const OperationTypeContainer = styled.div`
  display: flex;
  gap: 1rem 1.5rem;
`;

export const OrderByContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Title = styled(Text).attrs(() => ({ title: true }))`
  cursor: pointer;
  font-size: 1rem;
  color: ${({ isActived }) => (isActived ? '#FFFFFF' : 'rgb(184, 184, 184)')};

  :hover {
    color: #ffffff;
  }
`;

export const OrderByButton = styled.button.attrs(() => ({ type: 'button' }))`
  background-color: transparent;
  border: none;
`;

export default Container;
